import React, {
  createContext,
  useContext,
  useEffect,
  useMemo,
  useState
} from 'react';
import { useLocalStorage } from './LocalSess.js';
import { decryptData, encryptData } from 'helpers/Encrypth.js';
import PropTypes from 'prop-types';
import { client } from 'helpers/HttpClient.js';
import { Navigate } from 'react-router-dom';
const AuthContext = createContext({});

export const AuthProvider = ({ children }) => {
  const [userData, setUserData] = useLocalStorage('loginjmmsystem', null);
  const [auth, setAuth] = useState(null);
  const [redirect, setRedirect] = useState(null);

  const login = async data => {
    setAuth(true);

    setUserData(encryptData(data));
  };

  // call this function to sign out logged in user
  const logout = () => {
    setAuth(false);
    setUserData(null);
    setRedirect('/security/logout'); // trigger redirect
  };

  const isAdmin = () => {
    const dataUserEncr = decryptData(userData);
    return dataUserEncr.user.idrol == 1 || dataUserEncr.user.idrol == 2;
  };

  useEffect(() => {
    const interceptor = client.interceptors.response.use(
      response => response,
      error => {
        if (error.response?.status === 403) {
          logout();
        }
        return Promise.reject(error);
      }
    );

    // Cleanup on unmount (optional but good)
    return () => {
      client.interceptors.response.eject(interceptor);
    };
  }, []);
  const getSessionData = () => {
    if (!userData) return null;
    const dataUserEncr = decryptData(userData);
    return dataUserEncr;
  };
  const value = useMemo(
    () => ({
      userData,
      auth,
      login,
      logout,
      isAdmin,
      getSessionData
    }),
    [userData]
  );
  AuthProvider.propTypes = {
    children: PropTypes.node
  };
  return (
    <AuthContext.Provider value={value}>
      {children}
      {redirect && <Navigate to={redirect} replace />}
    </AuthContext.Provider>
  );
};

export const useAuth = () => {
  return useContext(AuthContext);
};
